<template>
  <BaseNoticeItem :button-text="$t('Edit Bank details')" :button-url="buttonUrl">
    <template #head>
      <strong>{{ $t('Missing bank details') }}</strong>
    </template>
    <template #body>
      {{ $t('You will need to complete your bank details in order to create a bill.') }}
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#bank-setup`
})
</script>
